<template xmlns:v-slot="http://www.w3.org/1999/XSL/Transform">
  <div class="subpage container">
    <Header v-if="$route.query.platform !== 'mini'" title="编辑收货地址" :is-sub-page="true" ref="navBarRef">
      <template v-slot:rightBtn>
        <span class="finish" @click="saveAddress('saveAddress')">完成</span>
      </template>
    </Header>
    <div class="editReceiveAddress">
      <div class="input-block">
        <span class="prepend-style">收货人</span>
        <cube-input placeholder='请输入收货人姓名' v-model="addressInfo.nameValue"  class="input"></cube-input>
      </div>
      <div class="input-block" style="margin-top:2px">
        <span class="prepend-style">手机号码</span>
        <cube-input placeholder='请输入手机号码' v-model="addressInfo.phoneValue" class="input" ></cube-input>
      </div>
      <div class="select-block" >
        <span class="prepend-style">省市地区</span>
        <div style="display: flex; width: 6.96rem;">
          <div class="click-select" @click="showAddressPicker">
            <span :style="[{fontSize:16+'px',color:'#545454'}]" style="text-align: left;">{{addressInfo.selectedText}}</span>
          </div>
          <img src="@/assets/images/icons/icon-down-arrow.png" class="selectImage" @click="showAddressPicker"/>
        </div>
      </div>
      <div class="input-block addressLl">
        <span class="prepend-style" style="align-items:flex-start">详细地址</span>
        <cube-textarea class="addressContent" :indicator="false" placeholder='请输入详细地址(5-120个字)' :autoExpand="true" v-model="addressInfo.textarea"></cube-textarea>
      </div>
    </div>
    <div v-if="$route.query.platform === 'mini'" class="fixed-button">
      <div class="conversion-button safe-padding" @click="saveAddress('saveAddress')">完成</div>
    </div>
  </div>
</template>

<script>
import Header from '@/components/Header'
import areaData from '@/assets/area'
import { queryAddress, updateAddress } from '@/api/shop'
// text用于显示
const cityData = JSON.parse(JSON.stringify(areaData))
cityData.forEach(province => {
  province.children = province.cityList
  province.text = province.name
  province.children.forEach(city => {
    city.children = city.areaList
    city.text = city.name
    city.areaList.forEach((area) => {
      area.text = area.name
    })
  })
  delete province.cityList
  delete province.children.areaList
})
export default {
  name: '',
  data () {
    return {
      addressInfo: {
        nameValue: '',
        phoneValue: '',
        textarea: '',
        selectedText: '点击选择'
      }
    }
  },
  mounted () {
    document.title = '编辑收货地址'

    this.addressInfo = this.$store.state.userInfo.addressInfo
    this.$on('saveAddress', this.saveAddress)
    this.addressPicker = this.$createCascadePicker({
      title: '省市地区',
      data: cityData,
      onSelect: this.selectHandle,
      onCancel: this.cancelHandle
    })
    this.getAddress()
  },
  components: {
    Header
  },
  methods: {
    // slot中的元素上绑定的事件居然在本组件可以触发？
    saveAddress () {
      this.$store.commit('userInfo/setAddressInfo', this.addressInfo)
      var str = null
      const addr = this.addressInfo.selectedText
      if (addr.length !== 0 && addr !== '点击选择') {
        str = addr.split(' ')
        if (str.length === 2) {
          str[2] = str[1]
          str[1] = str[0]
        }
      }
      if (str == null) {
        this.$createToast({
          txt: '请选择省市',
          type: 'txt'
        }).show()
        return
      }
      if (!(/^1(3|4|5|6|7|8|9)\d{9}$/.test(this.addressInfo.phoneValue))) {
        this.$createToast({
          txt: '手机号有误',
          type: 'txt'
        }).show()
        return
      }

      if (this.addressInfo.textarea.length < 5) {
        this.$createToast({
          txt: '详细地址不能小于5个字',
          type: 'txt'
        }).show()
        return
      }
      if (this.addressInfo.textarea.length > 120) {
        this.$createToast({
          txt: '详细地址不能大于120个字',
          type: 'txt'
        }).show()
        return
      }

      updateAddress({
        name: this.addressInfo.nameValue,
        phone: this.addressInfo.phoneValue,
        address: this.addressInfo.textarea,
        province: str[0],
        city: str[1],
        area: str[2]

      }).then((res) => {
        const toast = this.$createToast({
          txt: '保存成功',
          type: 'correct',
          time: 1000,
          onTimeout: () => {
            this.$router.back()
          }
        })
        toast.show()
      })
    },
    showAddressPicker () {
      this.addressPicker.show()
    },
    selectHandle (selectedVal, selectedIndex, selectedText) {
      if (selectedText[0] === selectedText[1]) {
        selectedText[1] = selectedText[2]
        selectedText.length = 2
      }
      this.addressInfo.selectedText = selectedText.join(' ')
      console.log(this.addressInfo.selectedText)
    },
    cancelHandle () {
      // this.$createToast({
      //   type: 'correct',
      //   txt: 'Picker canceled',
      //   time: 1000
      // }).show()
    },
    getAddress () {
      queryAddress({}).then((res) => {
        this.addressInfo.nameValue = res.data.name
        this.addressInfo.phoneValue = res.data.phone
        this.addressInfo.selectedText = res.data.city + ' ' + res.data.province + ' ' + res.data.area
        this.addressInfo.textarea = res.data.address
      })
    }

  }
}
</script>

<style lang="stylus" scoped>
.editReceiveAddress
  .prepend-style
    margin-left 20px;
    font-size 15px;
    color #545454;
    display flex;
    align-items center;
  .input-block
    height 50px;
    display flex;
    justify-content space-between;
    background-color #FFFFFF;
    margin-top 5px;
    .input
      width:261px;
      position:static;
      font-weight:400;
      color:rgba(84,84,84,1);
      font-size:15px;
  .select-block
    height 50px;
    display flex;
    justify-content space-between;
    align-items center;
    background-color #FFFFFF;
    margin-top 2px
    .click-select
      padding-left 10px;
      width 200px;
      display flex;
      justify-content flex-start
    .selectImage
      height 11px;
      width 17px;
      margin-left 10px
  .addressLl
    height 90px
    display flex;
    align-items center
    margin-top 2px
    .addressContent
      width:261px;
      height 100%
      position:static;
      font-size:15px
      align-items center
.fixed-button
  position: fixed;
  bottom: 0px;
  height: 49px;
  width: 100%;
  background-color: #ffffff;
  display: flex;
  justify-content: space-between;
  align-items: center;
  color: #545454;
  .conversion-button
    background-color: #662C85;
    height: 49px;
    width: 100%;
    display: flex;
    justify-content: center;
    align-items: center;
    color: #FFFFFF;
    font-size: 15px;
</style>

<style lang="stylus">
body
  background-color #f7f7f7
</style>
